import { useTranslation } from 'react-i18next'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { SpacingWrapper } from '@/shared/theme/styled-components'
import useIdentity from './useIdentity'
import useIdentityValidation from './useIdentityValidation'

interface Props {
  type?: 'warning' | 'error'
  marginTop?: string
}

const IdentityDataError = ({ type = 'warning', marginTop }: Props) => {
  const { t } = useTranslation()
  const { hidden, hasError } = useIdentity()
  useIdentityValidation()

  if (hidden || !hasError) return null

  const messageKey = type === 'error' ? 'incomplete_error' : 'contract_warning'

  return (
    <SpacingWrapper $marginTop={marginTop} $marginBottom='0.5rem'>
      {/* @ts-ignore */}
      <SDNotification type={type} border={type === 'error'} primaryText={t(`subscriptionForm:identity_module.${messageKey}`)} />
    </SpacingWrapper>
  )
}

export default IdentityDataError
